export const ACTION_TYPES = {
  FREEZE: 'freeze',
  DELETE: 'delete',
  ACTIVATE: 'activate',
  EDIT: 'edit',
} as const;
